export default "__VITE_ASSET__D1zQvM8Z__"